



























































import {
    Component,
    Vue
} from "vue-property-decorator";
import {
    Getter
} from "vuex-class";
import {
    Language
} from '@/models/Language';
@Component
export default class QuizScore extends Vue {
    @Getter('userLanguageId') private currentLanguage!: Language;
}
